import React from 'react';
import { Typography } from '@mui/material';
import { colors, fonts } from '../../../constants';

/**
 * FieldLabel Component
 * Reusable field label for query modal
 * 
 * @param {string} label - Label text
 */
const FieldLabel = ({ label }) => {
  return (
    <Typography
      variant="body2"
      sx={{
        fontSize: fonts.fontSizeSm,
        fontWeight: fonts.weightSemiBold,
        color: colors.textPrimaryDark,
        mb: '4px',
        display: 'block',
        lineHeight: 1.4,
        letterSpacing: '0.01em',
      }}
    >
      {label}
    </Typography>
  );
};

export default FieldLabel;
